import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

interface FieldChangeEvent {
  fieldKey: string;
  value: string;
}

@Component({
  selector: 'app-job-request-test-density-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './job-request-test-density-detail.component.html',
  styleUrl: './job-request-test-density-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobRequestTestDensityDetailComponent {
  @Input({ required: true }) testKey = '';
  @Input({ required: true }) specificGravity = '';
  @Input({ required: true }) densityPpg = '';

  @Output() fieldChanged = new EventEmitter<FieldChangeEvent>();

  protected onSpecificGravityInput(value: string): void {
    this.fieldChanged.emit({ fieldKey: 'specificGravity', value });
  }
}
